// Local translations
export const T = {
  en_GB: {
    expandTable: "Expand table",
    table: "Table",
    expandedView: "Expanded view of the table data.",
    row: "row",
    rows: "rows",
  },
  nb_NO: {
    expandTable: "Utvid tabell",
    table: "Tabell",
    expandedView: "Utvidet visning av tabelldataene.",
    row: "rad",
    rows: "rader",
  },
} as const;
